import { useTranslation } from 'react-i18next'
import { SUBSCRIPTION_STATUS_STYLES, type SubscriptionStatus } from '@structural-climbing/ui'

export function SubBadge({ status }: { status: SubscriptionStatus | undefined }) {
  const { t } = useTranslation()
  if (!status) {
    return (
      <span className="rounded-full bg-default/10 px-2 py-0.5 text-xs text-foreground/40">
        {t('members.noSubscription')}
      </span>
    )
  }
  return (
    <span
      className={`rounded-full px-2 py-0.5 text-xs font-medium ${SUBSCRIPTION_STATUS_STYLES[status]}`}
    >
      {t(`members.subStatus_${status}`)}
    </span>
  )
}
